import { useParams, Link } from 'react-router-dom';
import PageSEO from '@/components/base/PageSEO';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

const categoryKeywords: Record<string, string> = {
  'tongren-xiaoshuo': '火影忍者同人小说,火影同人文,火影小说创作,火影忍者二次创作小说',
  'tongren-chahua': '火影忍者同人插画,火影同人图,火影绘画教程,火影忍者二次创作插画',
  'cp-tongren': '火影忍者CP同人,火影CP配对,鸣佐同人,火影CP创作',
  'tongren-juqing': '火影忍者同人剧情,火影平行世界,火影IF线,火影剧情创作',
  'chuangzuo-jiaocheng': '火影忍者同人创作教程,火影同人写作教程,火影绘画入门,火影创作指南',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-16">
        <p className="text-foreground-600">分类未找到</p>
      </div>
    );
  }

  const seoTitle = `${category.name} - 火影忍者同人创作指南`;
  const seoDesc = category.description;
  const seoKeywords = categoryKeywords[slug] || '';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: category.name,
    description: category.description,
    url: `https://naruto-fancreations.com/category/${slug}`,
  };

  return (
    <>
      <PageSEO
        title={seoTitle}
        description={seoDesc}
        canonicalUrl={`https://naruto-fancreations.com/category/${slug}`}
        keywords={seoKeywords}
        jsonLd={jsonLd}
      />
      <main className="pt-20">
        <div className="w-full px-4 md:px-6 py-8">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />

            <div className="mt-4 mb-10">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className={`${category.icon} text-2xl`}></i>
                </div>
                <div>
                  <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                    {category.name}
                  </h1>
                  <p className="text-foreground-600 text-sm mt-1">
                    {category.description}
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} variant="default" />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无文章，敬请期待</p>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
}